import { Component, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

import { MessageComponent } from "../shared/component/message/message.component";
import { UnconformityService } from "../shared/service/unconformity.service";
import { UnconformityModel } from "../shared/model/unconformity.model";

@Component({
  selector: "app-unconformity",
  templateUrl: "./unconformity.component.html",
  styleUrls: ["./unconformity.component.css"],
})
export class UnconformityComponent implements OnInit {  
  @ViewChild(MessageComponent) message: MessageComponent

  lastEvent: any;
  totalRecords: number;
  unconformities: UnconformityModel[] = [];
  unconformity: UnconformityModel = new UnconformityModel();

  selectedMethod = '';
  selectedOrdenation = '';

  ascDesc = [];

  ordenation = [];

  criticalities = [];
  
  constructor(
    private unconformityService: UnconformityService,
    private translateService: TranslateService
  ) { }

  ngOnInit() { }

  lazy(e) {
    let description = e.filters['description'] ? e.filters['description'].value : null;
    this.lastEvent = e;
    this.unconformityService.getPaginated(e.first, e.rows, description).subscribe(unconformities => {
    this.unconformities = unconformities['rows'] as UnconformityModel[];
    this.totalRecords = unconformities['count'];
    this.loadOrdenation()
    });
  }

  loadOrdenation() {
    this.ascDesc = [
      { value: 'asc', label: this.translate('asc') },
      { value: 'desc', label: this.translate('desc') },
    ];

    this.ordenation = [
      { value: 'created_at', label: this.translate('creation_date') },
      { value: 'description', label: this.translate('alph_order') },
      { value: 'criticality', label: this.translate('criticality_level') }
    ];

    this.criticalities = [
      { value: 0, label: this.translate('low_criticality') },
      { value: 1, label: this.translate('medium_criticality') },
      { value: 2, label: this.translate('high_criticality') },
      { value: 3, label: this.translate('no_tolerance') }
    ];
  }

  onSelect(e) {
    this.unconformity = e.data as UnconformityModel;
  }

  getColor(criticality) {
    switch (criticality) {
      case 1:
        return 'yellow'
      case 2:
        return 'red'
      case 3:
        return 'black'
      default:
        return 'blue'
    }
  }

  onSave() {
    this.unconformityService.save(this.unconformity).subscribe(result => {
      this.message.success();
      this.lazy(this.lastEvent);
      this.onNew();
    });
  }

  onDelete() {
    this.unconformityService.delete(this.unconformity.id).subscribe(result => {
      this.message.success('Deletado com sucesso!');
      this.lazy(this.lastEvent);
      this.onNew();
    });
  }

  onNew() {
    this.unconformity = new UnconformityModel();
  }

  validate(): boolean {
    return UnconformityModel.validate(this.unconformity) && !this.duplicateValidation();
  }

  duplicateValidation() {
    return !this.unconformity.id && this.unconformities.findIndex((list) => list.description == this.unconformity.description) > -1;
  }

  order() {
		this.unconformities = _.orderBy(this.unconformities, this.selectedOrdenation, this.selectedMethod);
  }

  translate = (key: string) => this.translateService.instant(key || "invalid");
	tUpper = (key) => this.translate(key).toString().toUpperCase();
	tCap = (key) => this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/unconformity/unconformity.component.ts